import { composeIO } from 'react-compose-io'
import { cicloInformacaoIO } from './CicloInformacao.IO'
import CicloInformacaoView from './CicloInformacao.View'

export const CicloInformacao = composeIO(CicloInformacaoView, cicloInformacaoIO)
